import { LocaleRelativeTime } from '@mi-front/ui';
import { Typography } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

/**
 * Renders fragment creation time as relative time (e.g. "2 hours ago")
 * with full date/time in the native title tooltip.
 */
export function FragmentCardRelativeTime({
  createdAt,
  sx,
}: {
  createdAt: string;
  sx?: SxProps<Theme>;
}) {
  return (
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{ '&::first-letter': { textTransform: 'capitalize' }, ...sx }}
      title={new Date(createdAt).toLocaleString()}
    >
      <LocaleRelativeTime value={createdAt} />
    </Typography>
  );
}
